var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBetUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    stroke: "#848491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3625_25843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50037 9.25L3.41671 9.25C2.79787 9.25 2.20438 9.49583 1.76679 9.93342C1.32921 10.371 1.08337 10.9645 1.08337 11.5833V12.75",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75033 6.91667C7.03899 6.91667 8.08366 5.872 8.08366 4.58333C8.08366 3.29467 7.03899 2.25 5.75033 2.25C4.46166 2.25 3.41699 3.29467 3.41699 4.58333C3.41699 5.872 4.46166 6.91667 5.75033 6.91667Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13C12.1569 13 13.5 11.6569 13.5 10C13.5 8.34315 12.1569 7 10.5 7C8.84315 7 7.5 8.34315 7.5 10C7.5 11.6569 8.84315 13 10.5 13Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7504 10.8C11.7504 11.525 11.1254 11.92 10.3754 11.92C9.83039 11.92 9.38539 11.82 9.02539 11.45L9.58539 10.89C9.77039 11.075 10.0954 11.14 10.3804 11.14C10.7254 11.14 10.8904 11.025 10.8904 10.82C10.8904 10.735 10.8704 10.665 10.8204 10.61C10.7754 10.565 10.7004 10.53 10.5854 10.515L10.1554 10.455C9.84039 10.41 9.60039 10.305 9.44039 10.14C9.27539 9.97005 9.19539 9.73005 9.19539 9.42505C9.19539 8.77505 9.68539 8.30005 10.4954 8.30005C11.0054 8.30005 11.3904 8.42005 11.6954 8.72505L11.1454 9.27505C10.9204 9.05005 10.6254 9.06505 10.4704 9.06505C10.1654 9.06505 10.0404 9.24005 10.0404 9.39505C10.0404 9.44005 10.0554 9.50505 10.1104 9.56005C10.1554 9.60505 10.2304 9.65005 10.3554 9.66505L10.7854 9.72505C11.1054 9.77005 11.3354 9.87005 11.4854 10.02C11.6754 10.205 11.7504 10.47 11.7504 10.8Z",
    fill: "#848491"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 1,
    height: 4,
    fill: "#848491"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3625_25843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetUser);
export default __webpack_public_path__ + "static/media/bet-user.81f8e1fdae4c64e9974b20696346e5e7.svg";
export { ForwardRef as ReactComponent };